<script setup lang="ts">
  import { useI18n } from 'vue-i18n'
  import { useAuthDialog } from '@/composables/useAuthDialog.ts'
  import router from '@/router'

  const model = defineModel<boolean>()
  const { t } = useI18n()
  const authDialog = useAuthDialog()

  const login = () => {
    model.value = false
    authDialog.show()
  }

  const deleteChat = () => {
    model.value = false
    router.push('/')
  }
</script>

<template>
  <v-dialog
    v-model="model"
    max-width="440"
  >
    <v-card class="rounded-xl pa-4">
      <v-card-item class="pa-0">
        <div class="d-flex justify-end">
          <v-btn
            color="grey-500"
            icon="mdi-close"
            size="small"
            variant="text"
            @click="model = false"
          />
        </div>
      </v-card-item>

      <v-card-text class="text-center px-3 pt-0">
        <h2 class="text-h5 font-weight-bold mb-4">{{ t('clear_chat_title') }}</h2>
        <p class="text-weight-bold text-grey-500 mb-8">{{ t('clear_chat_subtitle') }}</p>

        <v-btn
          block
          class="text-subtitle-1 mb-4 font-weight-bold"
          color="primary"
          flat
          height="52"
          rounded="lg"
          @click="login"
        >
          {{ t('new_session_login') }}
        </v-btn>

        <v-btn
          block
          class="text-subtitle-1 font-weight-bold text-green-400"
          height="52"
          rounded="lg"
          variant="outlined"
          @click="deleteChat"
        >
          {{ t('new_session_delete') }}
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.v-btn {
  letter-spacing: 0;
}
</style>
